import { forwardRef } from "react"

import { cn } from "@f2e/ui/lib/utils"

import { Icons } from "@/components/icons"

interface CopilotLauncherProps {
  isOpen: boolean
  ariaLabel?: string
  ariaControls?: string
  ariaExpanded?: boolean
  title?: string
  onClick: () => void
}

const CopilotLauncher = forwardRef<HTMLButtonElement, CopilotLauncherProps>(
  ({ isOpen, ariaLabel, ariaControls, ariaExpanded, title, onClick }, ref) => {
    if (isOpen) return null

    return (
      <button
        ref={ref}
        type="button"
        aria-label={ariaLabel}
        aria-controls={ariaControls}
        aria-expanded={ariaExpanded}
        title={title}
        className={cn(
          "pointer-events-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary",
          "text-primary-foreground",
          "shadow-[0_22px_38px_-20px_rgba(15,23,42,0.55)] transition-transform duration-200 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
          "dark:shadow-[0_22px_32px_-16px_rgba(15,23,42,0.85)]",
          "hover:scale-105"
        )}
        onClick={onClick}
      >
        <Icons.logo className="h-10 w-10 dark:hidden" />
        <Icons.logoDark className="hidden h-10 w-10 dark:block" />
      </button>
    )
  }
)

export default CopilotLauncher
